// extracted by mini-css-extract-plugin
export default {"innerWrapper":"lw-z","tooltipWrapper":"mw-z","icon":"nw-z","tooltip":"ow-z","content":"pw-z"};